import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useDraggableActivator } from "@ryde/controls";

export const KanbanPassengerDragGrip: FC = () => {
  const { listeners, setActivatorNodeRef } = useDraggableActivator();

  return (
    <span className="drag_grip" ref={setActivatorNodeRef} {...listeners}>
      <SVG_MUI.GripVerticalSVG />
    </span>
  );
};

export const KanbanPassengerDragGripPlaceholder: FC = () => (
  <span className="drag_grip drag_grip--placeholder" aria-hidden>
    <span className="drag_grip-placeholder-diamond" />
  </span>
);
